import { ApolloLink } from '@apollo/client';

// Exports
/** Sets authorization header */
export const baseAuthMiddleware = (accessToken?: string) => {
  return new ApolloLink((operation, forward) => {
    if (accessToken) {
      operation.setContext({
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
      });
    }
    return forward(operation);
  });
};
